module.exports = __webpack_public_path__ + "static/media/cat_cover_2.7686a4ba.png";